'use strict';

function entry () {
    $(document).on('keyup blur', '#q, .cart-coupon-code input', function () {
        if ($(this).val().trim().length) {
            return $(this).siblings('button').prop('disabled', false);
        }

        $(this).siblings('button').prop('disabled', true);
    });
}

export default entry;
